import { ResourcesPermissionsV2 } from '../constants/PermissionsV2'
import { fetchPermissionsV2 } from '../services/permissions/permissionsV2.service'

const CUSTOMER_ID_KEY = 'cop:customer-id'
const SECTION_IDS = ['cop-resources-cyber-security-files', 'cop-resources-cyber-security-files-tab']
const VISIBLE_BODY_CLASS = 'cop-cyber-patch-files-visible'

function isGraniteAuthor(): boolean {
    return Boolean((window as unknown as { Granite?: { author?: unknown } }).Granite?.author)
}

function sectionsExist(): boolean {
    return SECTION_IDS.some(id => document.getElementById(id) !== null)
}

function reveal(): void {
    // Adds a body class so the stylesheet's default `display: none` on the
    // sections is overridden by the more specific `body.<class> #id` rule.
    // Clearing inline styles would NOT work — the id rule would still hide them.
    document.body.classList.add(VISIBLE_BODY_CLASS)
}

async function init(): Promise<void> {
    // Not on a page that renders the cybersecurity patch files section.
    if (!sectionsExist()) {
        return
    }

    // Author mode: keep the section visible so editors can see and edit it.
    if (isGraniteAuthor()) {
        reveal()
        return
    }

    const customerId = sessionStorage.getItem(CUSTOMER_ID_KEY) ?? ''
    if (!customerId) {
        // No customer context → treat as denied; section stays hidden (CSS default).
        return
    }

    try {
        const data = await fetchPermissionsV2(customerId)
        const canView = data.permissions.some(p => p.name === ResourcesPermissionsV2.CybersecurityViewPatchFiles)
        if (canView) {
            reveal()
        }
        // Denied → leave hidden (CSS default), so there is no show-then-hide flicker.
    } catch {
        // On failure keep the section hidden.
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        void init()
    })
} else {
    void init()
}
